import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ReservationService} from '../../trip-reservations/reservations.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {T2AutoCompleteLocationModule} from '../t2-autocomplete-location/t2-autocomplete-location.module';
import {SearchLocationTripComponent} from './search-location-trip.component';
import {AutoCompleteFacilitiesModule} from '../auto-complete-facilities/auto-complete-facilities.module';
import {Trip2ThemeModule} from '../../../trip2-theme/trip2-theme.module';
import {PreviousAddressModule} from '../previous-address/previous-address.module';
import {FacilitiesPayorModule} from '../facilities-payor/facilties-payor.module';
import {TextMaskModule} from 'angular2-text-mask';
import { GoogleMapsModule } from '../google-maps/google-maps.module';
import { MapPinAdjustmentModule } from '../map-pin-adjustment/map-pin-adjustment.module';
import { PhoneNumberModule } from 'app/utils/phone-number/phone-number.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    T2AutoCompleteLocationModule,
    AutoCompleteFacilitiesModule,
    Trip2ThemeModule,
    PreviousAddressModule,
    FacilitiesPayorModule,
    TextMaskModule,
    GoogleMapsModule,
    MapPinAdjustmentModule,
    PhoneNumberModule
  ],
  declarations: [
    SearchLocationTripComponent
  ],
  exports: [
    SearchLocationTripComponent
    ],
  providers: [
    ReservationService
  ]
})
export class SearchLocationTripModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/search-location-trip/search-location-trip.module.ts